document.addEventListener('DOMContentLoaded', () => {
  const topbar = document.querySelector('#topbar');
  if (!topbar) return;

  let lastScroll = window.pageYOffset || window.scrollY;
  let ticking = false;
  const threshold = 10;

  const showClasses = ['translate-y-0', 'opacity-100'];
  const hideClasses = ['-translate-y-full', 'opacity-0', 'pointer-events-none'];

  const show = () => {
    topbar.classList.add(...showClasses);
    topbar.classList.remove(...hideClasses);
  };

  const hide = () => {
    topbar.classList.add(...hideClasses);
    topbar.classList.remove(...showClasses);
  };

  const update = () => {
    const currentScroll = window.pageYOffset || window.scrollY;

    // Na górze strony topbar zawsze ma być widoczny
    if (currentScroll <= 10) {
      show();
      lastScroll = currentScroll;
      ticking = false;
      return;
    }

    const diff = currentScroll - lastScroll;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Scroll w dół
        hide();
      } else {
        // Scroll w górę
        show();
      }

      lastScroll = currentScroll;
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  // Początkowy stan po załadowaniu strony
  if ((window.pageYOffset || window.scrollY) <= 10) {
    show();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
});